import { render, staticRenderFns } from "./RakoonChat.vue?vue&type=template&id=089a4ed3&scoped=true"
import script from "./RakoonChat.vue?vue&type=script&lang=js"
export * from "./RakoonChat.vue?vue&type=script&lang=js"
import style0 from "./RakoonChat.vue?vue&type=style&index=0&id=089a4ed3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089a4ed3",
  null
  
)

export default component.exports